import {format} from 'date-fns'
import {ru} from 'date-fns/locale'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {useFileViewerStore} from '../file-viewer-store'
import {ContentTypeIcon} from '../icons/type/content-type-Icon'

const TwName = tw.div`
  font-medium
  truncate
  leading-main
  text-14
  text-main-old-dark
`

const TwTime = tw.div`
  text-third-old-dark
  font-medium
  truncate
  leading-main
  text-14
  ml-16
`

type LocaleType = {locale: Locale}

const formatDateTime = (locale: LocaleType, ts: number) =>
  format(ts, 'dd LLL yyyy, HH:mm', locale).replaceAll('. ', ' ')

export const Info = observer(() => {
  const [state, store] = useFileViewerStore()
  const language = Lang.getLang()
  const locale = language === 'ru' ? {locale: ru} : undefined
  const ts = state.currentFile?.timestamp
  const time = ts > 0 ? formatDateTime(locale, ts) : undefined

  return (
    <div className="absolute left-16 top-16">
      <div className="flex items-center gap-4">
        <ContentTypeIcon contentType={state.currentFile?.contentType} />
        <TwName>{store.name}</TwName>
        {time && <TwTime>{time}</TwTime>}
      </div>
    </div>
  )
})
